<template>
  <div class="taskAssignment">
    <div class="taskAssignment__header">
      <div class="taskAssignment__header__top">
        <h1 class="medium-title">Assignment</h1>
        <span class="base-font" @click="newTask">New Task</span>
      </div>
      <div class="taskAssignment__header__bottom">
        <h1 class="large-font">Unassigned Task ({{this.tasksCount}})</h1>
      </div>
    </div>
    <div v-if="!isLoading"  class="taskAssignment__body">
      <div class="taskAssignment__body__left">
        <div v-if="isEmpty" class="card__emptyState"><adx-empty-selection/></div>
        <div v-else v-for="(task, index) in unassignedTasks" :key="index" class="card" @mouseover="toggleShowExpansion(true, `unassigned`, index)" @mouseleave="toggleShowExpansion(false, `unassigned`, index)">
          <div class="card__top">
            <div class="card__top__left">
              <p class="placement">{{task.placement}}</p>
              <p class="campaign">{{task.campaign}} • {{task.category_display}}</p>
            </div>
            <div class="card__top__right">
              <div v-if="isShowExpansion[index]" class="card__top__right__expansionWrapper"><adx-menu-expansion  :itemID="task.id" :lists="unassignedExpansionList" @selected="selected" /></div>
            </div>
          </div>
          <div class="card__bottom">
            <p>{{task.location}}</p>
            <div class="areaWrapper"><img src="/img/icons/ic-place.png" alt=""><p>{{task.area}}</p></div>
          </div>
        </div>
      </div>
      <div class="taskAssignment__body__right">
        <div class="taskAssignment__body__right__scroll">
          <div v-for="(assignedTask, toggleIndex) in assignedTasks" :key="toggleIndex" class="assigneeCard" @click="toggle(toggleIndex)">
            <div class="assigneeCard__assignee">
              <h1 class="base-font">{{assignedTask.full_name}} ({{assignedTask.tickets.length}})</h1>
              <div>
                <i v-if="!isCollapse[toggleIndex]" class="icon-chevrondown"></i>
                <i v-else class="icon-chevronup"></i>
              </div>
            </div>
            <div v-if="isCollapse[toggleIndex]" class="assigneeCard__body">
              <div v-for="(task, index) in assignedTask.tickets" :key="index" class="card" @mouseover="toggleShowExpansion(true, `assigned`, toggleIndex, index)" @mouseleave="toggleShowExpansion(false, `assigned`, toggleIndex, index)">
                <div class="card__top">
                  <div class="card__top__left">
                    <p class="placement">{{task.placement}}</p>
                    <p class="campaign">{{task.campaign}} • {{task.category_display}}</p>
                  </div>
                  <div class="card__top__right">
                    <div v-if="isShowExpansion2[toggleIndex][index]" class="card__top__right__expansionWrapper"><adx-menu-expansion :itemID="task.id" :lists="assignedExpansionList" @selected="selected"/></div>
                  </div>
                </div>
                <div class="card__bottom">
                  <p>{{task.location}}</p>
                  <div class="areaWrapper"><img src="/img/icons/ic-place.png" alt=""><p>{{task.area}}</p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="taskAssignment__loading" v-else-if="isLoading"><loading-primary /></div>
    <!-- <div class="taskAssignment__pagination" v-if="!isLoading && !isEmpty">
      <div class="total" >{{getDataRange}} of {{count}} Placements</div>
      <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/>
    </div> -->
    <adx-modal 
      v-if="showModal"
      type="small" 
      title="Are you sure want to delete this ticket ?"
      :noTitleTop="true" 
      :hideClose="true">
      <div slot="content" class="modal_delete">
        <button type="button" class="primary btn-regular delete" @click.stop="deleteTask">Delete</button>
        <button type="button" class="secondary btn-regular" @click.stop="cancelDelete">Cancel</button>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import LoadingPrimary from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'
import Pagination from '@/components/Pagination'
import Modal from '@/components/Modal'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-task-monitoring',
  components: {
    'adx-menu-expansion': MenuExpansion,
    'loading-primary': LoadingPrimary,
    'adx-empty-selection': EmptySelection,
    'adx-pagination': Pagination,
    'adx-modal': Modal,
  },
  props: {

  },
  data() {
    return {
      selectedPage: 1,
      count: 0,
      isCollapse: [],
      isShowExpansion: [],
      isShowExpansion2: [],
      tasksCount: 0,
      isEmpty: false,
      isLoading: false,
      unassignedExpansionList: [
        {
          "name": "Assign To",
          "value": "assignto",
          "items": []
        },
        {
          "name": "Delete Task",
          "value": "delete",
        }
      ],
      assignedExpansionList: [
        {
          "name": "Assign To",
          "value": "assignto",
          "items": []
        },
        {
          "name": "Set To Unassigned",
          "value": "unassign",
        },
        {
          "name": "Delete Task",
          "value": "delete"
        }
      ],
      unassignedTasks: [],
      assignedTasks: [],
      showModal: false,
      deleteSelected: null,
    }
  },
  computed: {
    getDataRange: function(){
      let endPage = this.selectedPage*10;
      return this.count > 10? ((endPage < this.count)? endPage: endPage-10+(this.count%10)) : this.count
    },
  },
  watch: {
    selectedPage: function(){
      this.count = 0;
      this.loadData()
    }
  },
  beforeCreate() {

  },
  created() {

  },
  async beforeMount() {
    await this.loadData()

    await this.unassignedTasks.map(() => {
      this.isShowExpansion.push(false)
    })

    await this.assignedTasks.map(task => {
      this.isCollapse.push(false)
      let arr = []
      task.tickets.map(()=> {
        arr.push(false)
      })
      this.isShowExpansion2.push(arr)
    })
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isLoading = true
      this.isEmpty = false

      // Unassigned ticket
      let params = {
        page: this.selectedPage
      }
      const unassignedResponse = await api.get(apiV2.taskManagerUnassignedTask, { needToken: true, params })
      if (unassignedResponse.status === 200) {
        const { data } = unassignedResponse
        this.tasksCount = data.count
        this.unassignedTasks = data.results
        if (!this.unassignedTasks.length) this.isEmpty = true
        this.maxPage = data.max_page
        this.count = data.count
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Sorry something went wrong! (Error code: ${unassignedResponse.status})`,
          type: 'warn'
        })
      }

      // Assigned ticket
      const assignedResponse = await api.get(apiV2.taskManagerAssignedTask, { needToken: true })
      if (assignedResponse.status === 200) {
        const { data } = assignedResponse
        this.assignedTasks = data
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Sorry something went wrong! (Error code: ${assignedResponse.status})`,
          type: 'warn'
        })
      }

      const opsResponse = await api.get(apiV2.getTeamOps, { needToken: true })
      if (opsResponse.status === 200) {
        const { data } = opsResponse

        this.unassignedExpansionList.map(list => {
          if (list.value === "assignto") {
            list.items = []
            data.map(obj => {
              list.items.push({
                id: obj.id,
                name: obj.full_name
              })
            })
          }
        })

        this.assignedExpansionList.map(list => {
          if (list.value === "assignto") {
            list.items = []
            data.map(obj => {
              list.items.push({
                id: obj.id,
                name: obj.full_name
              })
            })
          }
        })

      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Sorry something went wrong! (Error code: ${opsResponse.status})`,
          type: 'warn'
        })
      }

      this.isLoading = false
    },
    newTask() {
      this.$router.push({name: "newtask"})
    },
    toggle(index) {
      this.$set(this.isCollapse, index, !this.isCollapse[index])
    },
    selected(item) {
      if (item.value === "assignto") {
        this.assignTask(item.item_id, item.items.id)
      } else if (item.value == "delete") {
        this.deleteSelected = item.item_id
        this.toggleModal(item.item_id)
      } else {
        this.assignTask(item.item_id, null)
      }
    },
    toggleShowExpansion(value, type, index, index2) {
      if (type === "unassigned") {
        this.$set(this.isShowExpansion, index, value)
      } else {
        this.$set(this.isShowExpansion2[index], index2, value)
      }
    },
    async assignTask(task, assignee) {
      let body = {
        assignee: assignee
      }

      if (assignee) {
        const assignResponse = await api.put(apiV2.taskManagerAssignTask(task), body, { needToken: true })
        if (assignResponse.status === 200) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Task successfully assigned!`,
            type: 'success'
          })
          this.loadData()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: `Sorry something went wrong! (Error code: ${assignResponse.status})`,
            type: 'warn'
          })
        }
      } else {
        const unassignResponse = await api.patch(apiV2.taskManagerUnassignTask(task), {}, { needToken: true })
        if (unassignResponse.status === 200) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Task successfully set to unassigned!`,
            type: 'success'
          })
          this.loadData()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: `Sorry something went wrong! (Error code: ${unassignResponse.status})`,
            type: 'warn'
          })
        }
      }
    },
    selectPage(item) {
      this.selectedPage = item
    },
    deleteTask() {
      (async () => {
        const response = await api.patch(apiV2.taskManagerDeleteTicket(this.deleteSelected), {}, {needToken: true})
        if (response.status == 200) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Task successfully deleted`,
            type: 'success'
          })
          this.toggleModal()
          this.loadData()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Delete task failed`,
            type: 'warn'
          })
        }
      })();
    },
    toggleModal() {
      this.showModal = !this.showModal
    },
    cancelDelete() {
      this.deleteSelected = null
      this.toggleModal()
    }
  }
}
</script>

<style lang="scss">
.taskAssignment {
  .modal {
    .modal__content {
      .modal_delete {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;

        .delete {
          margin-right: 8px;
        }
      }
    }
  }
}


</style>


<style lang='scss' scoped>
@import './index.scss';
</style>
